import React from "react";
import { Dialog } from "primereact/dialog";
import { DialogBase, Props, State } from "./DialogBase";
import DynamicAccordionFormDesignComponent from "./DynamicAccordionFormDesignComponent";

export class DialogForDynamicAccordionFormComponent extends DialogBase<Props, State> {

    constructor(props: Props) {
        super(props);
    }

    generateHtmlString = () => {
        const ele = this.props.ele;

        return (
            <Dialog
                header={"Dynamic Accordion Form Settings - " + (this.props.isEng ? ele.ENUTitle : ele.FRATitle)}
                footer={this.renderFooter(this.props)}
                visible={this.props.dialogVisible}
                style={{ width: '70vw', maxWidth: '900px' }}
                onHide={() => this.props.callback(false)}
            >
                <DynamicAccordionFormDesignComponent
                    field={ele}
                    isEng={this.props.isEng}
                    callback={this.props.callback}
                />
            </Dialog>
        );
    }

    render() {
        return this.generateHtmlString();
    }
}
